import { useState, useCallback } from 'react';
import axios from 'axios';

const backendURL = window.__ENV && window.__ENV.backendURL;
const axiosClient = axios.create({ baseURL: `${backendURL}`, timeout: 20000, withCredentials: true, credentials: 'include' });
const config = { headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' } };

export default function useProducts() {
  const [products, setProducts] = useState();
  const [recentProducts, setRecentProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [recommendedProducts, setRecommededproducts] = useState([]);
  const [popularProducts, setPopularproducts] = useState([]);
  const [bestSellers, setBestSellers] = useState([]);
  const [mProduct, setmProduct] = useState([]);
  const [prodsPage, setProdsPage] = useState(0);
  const [prodsPerpage, setProdsPerpage] = useState(20);
  const [limit, setLimit] = useState(5);
  const [noMoreProducts, setNomoreProducts] = useState(false);
  const [showRecent, setShowRecent] = useState(true);
  const [recentPtmpCount, setrecentPtmpCount] = useState(0);
  const [recentPCount, setrecentPCount] = useState(0);

  // Example: fetch products
  const fetchProduct = useCallback(async (productid) => {
    const url = `${process.env.REACT_APP_SERVER_URL}/products/${productid}`;
    return axiosClient.get(url, config);
  }, []);

  // Example: search products
  const searchProduct = useCallback(async (searchString, usercountryscope) => {
    const url = `${process.env.REACT_APP_SERVER_URL}/products/find/${searchString}`;
    return axiosClient.post(url, { countryscopes: usercountryscope }, config);
  }, []);

  // Add more product-related functions as needed...

  return {
    products,
    setProducts,
    recentProducts,
    setRecentProducts,
    filteredProducts,
    setFilteredProducts,
    recommendedProducts,
    setRecommededproducts,
    popularProducts,
    setPopularproducts,
    bestSellers,
    setBestSellers,
    mProduct,
    setmProduct,
    prodsPage,
    setProdsPage,
    prodsPerpage,
    setProdsPerpage,
    limit,
    setLimit,
    noMoreProducts,
    setNomoreProducts,
    showRecent,
    setShowRecent,
    recentPtmpCount,
    setrecentPtmpCount,
    recentPCount,
    setrecentPCount,
    fetchProduct,
    searchProduct,
  };
}
